export const LEAD_FORM_NAMES = {
  EMBEDDED: 'EMBEDDED',
  UCI: 'UCI',
  CONFIGURATOR: 'CONFIGURATOR',
  DIGITAL_RETAIL_OFFER_TYPE: 'DIGITAL_RETAIL_OFFER_TYPE',
  MULTI_DIGITAL_RETAIL_OFFER_TYPE: 'MULTI_DIGITAL_RETAIL_OFFER_TYPE',
  MULTI_DIGITAL_RETAIL_OFFER_TYPE_SRP_NEW: 'MULTI_DIGITAL_RETAIL_OFFER_TYPE_SRP_NEW',
  MULTI_DIGITAL_RETAIL_OFFER_TYPE_SRP_USED: 'MULTI_DIGITAL_RETAIL_OFFER_TYPE_SRP_USED',
  SIMPLE_INVENTORY_LEAD_FORM: 'SIMPLE_INVENTORY_LEAD_FORM',
};
